import { IForm } from '@/components/types'
import { useSearchDateShortcut } from '@/hooks/useSearch'
// const shortcuts = useSearchDateShortcut()
const shortcuts =
  [
    {
      text: '昨天',
      value: () => {
        // 获取昨天的开始时间（00:00:00）
        const start = new Date();
        start.setDate(start.getDate() - 1);
        start.setHours(0, 0, 0, 0);
        // 获取昨天的结束时间（23:59:59）
        const end = new Date();
        end.setDate(end.getDate() - 1);
        end.setHours(23, 59, 59, 999);
        return [start, end]
      }
    },
    {
      text: '近7天',
      value: () => {
        const start = new Date();
        start.setDate(start.getDate() - 7);
        start.setHours(0, 0, 0, 0);
        const end = new Date();
        end.setDate(end.getDate() - 1);
        end.setHours(23, 59, 59, 999);
        return [start, end]
      }
    },
    {
      text: '近30天',
      value: () => {
        const start = new Date();
        start.setDate(start.getDate() - 30);
        start.setHours(0, 0, 0, 0);
        const end = new Date();
        end.setDate(end.getDate() - 1);
        end.setHours(23, 59, 59, 999);
        return [start, end]
      }
    }
  ]


export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '企业',
      clearable: true,
      placeholder: '请选择企业',
      filterable: true,
      options: []
    },
    {
      field: 'groupName',
      type: 'select',
      label: '组',
      placeholder: '请选择组',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      field: 'deptName',
      type: 'select',
      label: '岗位',
      clearable: true,
      placeholder: '请选择岗位',
      filterable: true,
      options: [
        { title: '全部', value: '' },
        { title: '518', value: '518' },
        { title: '投教', value: '投教' }
      ]
    },
    {
      label: '账户ID',
      field: 'userId',
      clearable: true,
      type: 'input',
      placeholder: '请输入账户ID'
    },
    {
      label: '名称',
      field: 'name',
      clearable: true,
      type: 'input',
      placeholder: '请输入名称'
    },
    {
      label: '使用人',
      field: 'usedBy',
      type: 'select',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'duration',
      type: 'select',
      label: '单次时长',
      placeholder: '请选择单次时长',
      options: [
        { title: '不限', value: 0 },
        { title: '>1分钟', value: 1.000001 },
        { title: '>2分钟', value: 2.000001 },
        { title: '≥5分钟', value: 5 },
        { title: '≥10分钟', value: 10 },
        { title: '≥15分钟', value: 15 },
        { title: '≥20分钟', value: 20 }
      ]
    },
    {
      field: 'callCount',
      type: 'select',
      label: '通话量',
      placeholder: '请选择通话量',
      options: [
        { title: '不限', value: 0 },
        { title: '>10次', value: 10.000001 },
        { title: '>20次', value: 20.000001 },
        { title: '≥30次', value: 30 },
        { title: '≥50次', value: 50 },
        { title: '≥100次', value: 100 }
      ]
    },
    {
      field: 'timeSlot',
      type: 'dateTimePicker',
      label: '通话时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          return yesterday < date
        },
        shortcuts: shortcuts
      }
    }
  ]
}
